import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 20000,
});

// Attach bearer token as fallback (some browsers block third-party cookies)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("gbe_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Expired/invalid session: clear the stale token and return to login instead
// of silently failing every action (RCA: escalate button 401 after 8h session).
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    if (status === 401 && !url.includes("/auth/") &&
        !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("gbe_token");
      window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtCurrency(n, currency = "AUD") {
  if (n == null || Number.isNaN(Number(n))) return "—";
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(Number(n));
}

export function fmtNumber(n) {
  if (n == null || Number.isNaN(Number(n))) return "—";
  return new Intl.NumberFormat("en-AU").format(Number(n));
}
